/** workbench管理 */
const page = () => import("../../view/jofph/page");
const pageAdd = () => import("../../view/jofph/page/add");

const model = "/jofph";
const path = model + "/page";

export default [
  {
    // 数据统计
    path: path,
    component: page,
    name: "page",
  },
  {
    // 文章详情统计
    path: path + "/:page_id",
    component: pageAdd,
    name: "pageAdd",
  },
];
